import {Outlet} from 'react-router-dom'
import {ProjectsTabs} from '@/features/projects/components/projects-tabs/ProjectsTabs'
import {StyledProjectsLayout} from '@/layouts/projects-layout/style'

export const ProjectsLayout = () => {
    return (
        <StyledProjectsLayout>
            <ProjectsTabs />
            <Outlet />
        </StyledProjectsLayout>
    )
}
